import { FormField } from '@/models';
import { isDefined } from './util';

export function makeFormField(value?: string, formatted: string | null = null): FormField {
  return { value: value || '', dirty: false, formatted, error: null, errorMode: null, oldValue: null };
}

export function makeFormFieldOfType<T>(value: T): FormField<T> {
  return { value, dirty: false, formatted: null, error: null, errorMode: null, oldValue: null };
}

export function isFormField(value: any): value is FormField<any> {
  return value && isDefined(value.value) && isDefined(value.dirty);
}
